<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    d="M13 10.0078V11.5078C13 12.3362 12.3284 13.0078 11.5 13.0078H4.5C3.67157 13.0078 3 12.3362 3 11.5078V4.50781C3 3.67939 3.67157 3.00781 4.5 3.00781H6"
    stroke="#B5BCC4"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8 8.00781L13.0018 3.00781M13.0018 3.00781H9M13.0018 3.00781V7.00781"
    stroke="#B5BCC4"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
